export enum SpidTaskEnum {
  CREATE_DOSSIER = 'CREATE DOSSIER SPIDID',
  START_PROCESS = 'START PROCESS SPIDID',
  ONESHOT_REGISTER = 'ONESHOT REGISTER SPIDID',
  RESEND_OTP = 'SEND OTP SPIDID',
  SIGN = 'ISSUE AND SIGN SPIDID',
}

export enum SpidSseEventEnum {
  OK = 'SPIDID_EVENT_TYPE_OK',
  KO = 'SPIDID_EVENT_TYPE_KO',
  WARNING = 'SPIDID_EVENT_TYPE_WARNING',
}
